
export default {
  props: {
    addressInfo: {
      type: [Array, Object],
    },
    country: {
      type: String,
    },
  },
};
